export default __webpack_public_path__ + "df65be90f21e7e307462357bb553d9a6.png";